import { jsx as _jsx } from "react/jsx-runtime";
import { isMultienum } from 'customer-data-objects/property/PropertyIdentifier';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { isEmptyValue } from '../../validation/utils/isEmptyValue';
// only place where we filter options and get create a new definition
export const getNewDefinitionWithFilteredOptions = (propertyDefinition, conditionalPropertyOptionsRules) => {
  const optionValues = [];

  for (const conditionalPropertyOptionsRule of conditionalPropertyOptionsRules) {
    optionValues.push(...conditionalPropertyOptionsRule.dependentOptions);
  }

  if (optionValues.length === 0) {
    return propertyDefinition;
  }

  return Object.assign({}, propertyDefinition, {
    options: propertyDefinition.options.filter(option => optionValues.includes(option.value))
  });
};
export const isConditionalPropertyOptionsRuleActive = (values, conditionalPropertyOptionsRule) => values.includes(conditionalPropertyOptionsRule.controllingField.fieldValue);
export const getActiveConditionalPropertyOptionRules = (values, conditionalPropertyOptionsRules) => conditionalPropertyOptionsRules.filter(rule => isConditionalPropertyOptionsRuleActive(values, rule));
export const allValuesHaveRules = (values, conditionalPropertyOptionsRules) => values.length > 0 && conditionalPropertyOptionsRules.length > 0 && values.every(value => conditionalPropertyOptionsRules.some(rule => rule.controllingField.fieldValue === value));
export const getPropertyDefinitionsByRuleId = (propertyDefinition, conditionalPropertyOptionsRules) => conditionalPropertyOptionsRules.reduce((acc, rule) => {
  acc.set(rule.id, getNewDefinitionWithFilteredOptions(propertyDefinition, [rule]));
  return acc;
}, new Map());
export const getPropertyDefinitionForActiveRules = (originalPropertyDefinition, propertyDefinitionsByRuleId, activeConditionalPropertyOptionsRules) => {
  if (activeConditionalPropertyOptionsRules.length === 0) {
    return originalPropertyDefinition;
  }

  if (activeConditionalPropertyOptionsRules.length === 1) {
    return propertyDefinitionsByRuleId.get(activeConditionalPropertyOptionsRules[0].id);
  }

  if (activeConditionalPropertyOptionsRules.length > 1) {
    return getNewDefinitionWithFilteredOptions(originalPropertyDefinition, activeConditionalPropertyOptionsRules);
  }

  return originalPropertyDefinition;
}; // this error validation logic does not work for properties with external options
// As of Sep 2023, CPO tab is hidden for properties with external options. So, they cannot be set as dependent properties.
// Those properties are also disabled in controlling property selection. So, they cannot be set as controlling property.

export const getConditionalPropertyOptionsValidation = ({
  originalPropertyDefinition,
  propertyDefinitionForActiveRules,
  value,
  controllingFieldLabel
}) => {
  if (isEmptyValue(value)) {
    return {
      error: false,
      validationMessage: null
    };
  }

  const dependentFieldValues = isMultienum(originalPropertyDefinition) ? parseMultiEnumValue(value) : [value];
  const originalOptionValues = originalPropertyDefinition.options.map(option => option.value);
  const filteredOptionValues = propertyDefinitionForActiveRules.options.map(option => option.value);

  for (const dependentFieldValue of dependentFieldValues) {
    if (originalOptionValues.includes(dependentFieldValue) && !filteredOptionValues.includes(dependentFieldValue)) {
      return isMultienum(originalPropertyDefinition) ? {
        error: true,
        validationMessage: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: 'conditionalPropertyOptions.propertyInputV2.errors.hiddenOptionSelectedMulti',
          options: {
            controllingFieldLabel
          }
        })
      } : {
        error: true,
        validationMessage: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: 'conditionalPropertyOptions.propertyInputV2.errors.hiddenOptionSelected',
          options: {
            controllingFieldLabel
          }
        })
      };
    }
  }

  return {
    error: false,
    validationMessage: null
  };
};